import { CountryCodes } from '@constants'

export const ACTIONS = {
	SET_ACTIVE_REASON: 'SET_ACTIVE_REASON',
	SET_USER_LIST: 'SET_USER_LIST',
	SET_SELECTED_USER: 'SET_SELECTED_USER',
	OPEN_MODAL: 'OPEN_MODAL',
	CLOSE_MODAL: 'CLOSE_MODAL',
	SET_ADDRESS_LIST: 'SET_ADDRESS_LIST',
	SET_SELECTED_ADDRESS: 'SET_SELECTED_ADDRESS',
	SET_COMM_ADDRESS_LIST: 'SET_COMM_ADDRESS_LIST',
	SET_SELECTED_COMM_ADDRESS: 'SET_SELECTED_COMM_ADDRESS',
	SET_ADDRESS_MODAL_VIEW: 'SET_ADDRESS_MODAL_VIEW',
	SET_ADDRESS_SEARCH_QUERY: 'SET_ADDRESS_SEARCH_QUERY',
	SET_ADDRESS_SEARCH_RESULTS: 'SET_ADDRESS_SEARCH_RESULTS',
	SELECT_ADDRESS_FROM_SEARCH: 'SELECT_ADDRESS_FROM_SEARCH',
	UPDATE_NEW_ADDRESS: 'UPDATE_NEW_ADDRESS',
	UPDATE_NEW_USER: 'UPDATE_NEW_USER',
	RESET_NEW_USER: 'RESET_NEW_USER',
	SET_HEADOFFICE_ADDRESS: 'SET_HEADOFFICE_ADDRESS',
	SET_COMMUNICATION_ADDRESS: 'SET_COMMUNICATION_ADDRESS',
	SET_KYC_POC_DETAILS: 'SET_KYC_POC_DETAILS',
}

export const INITIAL_NEW_ADDRESS = {
	pincode: '',
	city: '',
	district: '',
	state: '',
	country: 'India',
	street_address: '',
}

const INITIAL_NEW_USER = {
	full_name: '',
	mobile_number: '',
	country_code: CountryCodes[0],
	email_id: '',
	role: '',
}

export const initialState = {
	isActiveReason: false,
	userList: [],
	selectedUser: null,
	activeModal: null,
	addressList: [],
	selectedAddress: null,
	commAddressList: [],
	selectedCommAddress: null,
	addressModalView: 'list',
	addressSearchQuery: '',
	addressSearchResults: [],
	newAddress: INITIAL_NEW_ADDRESS,
	newUser: INITIAL_NEW_USER,
	headofficeAddress: null,
	communicationAddress: null,
	kycPocDetails: null,
}

export const pocDetailsReducer = (state, action) => {
	switch (action.type) {
		case ACTIONS.SET_ACTIVE_REASON:
			return { ...state, isActiveReason: action.payload }

		case ACTIONS.SET_USER_LIST:
			return { ...state, userList: action.payload }

		case ACTIONS.SET_SELECTED_USER:
			return { ...state, selectedUser: action.payload }

		case ACTIONS.OPEN_MODAL: {
			const resetFormState = {
				addressModalView: 'list',
				newAddress: INITIAL_NEW_ADDRESS,
				addressSearchQuery: '',
				addressSearchResults: [],
			}
			return {
				...state,
				activeModal: action.payload,
				...(action.payload === 'addAddress' && { ...resetFormState, selectedAddress: null }),
				...(action.payload === 'addCommunicationAddress' && { ...resetFormState, selectedCommAddress: null }),
			}
		}

		case ACTIONS.CLOSE_MODAL:
			return { ...state, activeModal: null }

		case ACTIONS.SET_ADDRESS_LIST:
			return { ...state, addressList: action.payload }

		case ACTIONS.SET_SELECTED_ADDRESS:
			return { ...state, selectedAddress: action.payload }

		case ACTIONS.SET_COMM_ADDRESS_LIST:
			return { ...state, commAddressList: action.payload }

		case ACTIONS.SET_SELECTED_COMM_ADDRESS:
			return { ...state, selectedCommAddress: action.payload }

		case ACTIONS.SET_ADDRESS_MODAL_VIEW:
			return {
				...state,
				addressModalView: action.payload,
				...(action.payload === 'form' && {
					newAddress: INITIAL_NEW_ADDRESS,
					addressSearchQuery: '',
					addressSearchResults: [],
				}),
			}

		case ACTIONS.SET_ADDRESS_SEARCH_QUERY:
			return { ...state, addressSearchQuery: action.payload, addressSearchResults: [] }

		case ACTIONS.SET_ADDRESS_SEARCH_RESULTS:
			return { ...state, addressSearchResults: action.payload }

		case ACTIONS.SELECT_ADDRESS_FROM_SEARCH:
			return {
				...state,
				newAddress: {
					...INITIAL_NEW_ADDRESS,
					id: action.payload.id,
					pincode: action.payload.pincode ?? '',
					city: action.payload.city ?? '',
					district: action.payload.district ?? '',
					state: action.payload.state ?? '',
					country: action.payload.country ?? 'India',
				},
			}

		case ACTIONS.UPDATE_NEW_ADDRESS:
			return { ...state, newAddress: { ...state.newAddress, [action.payload.field]: action.payload.value } }

		case ACTIONS.UPDATE_NEW_USER:
			return { ...state, newUser: { ...state.newUser, [action.payload.field]: action.payload.value } }

		case ACTIONS.RESET_NEW_USER:
			return { ...state, newUser: INITIAL_NEW_USER }

		case ACTIONS.SET_HEADOFFICE_ADDRESS:
			return { ...state, headofficeAddress: action.payload }

		case ACTIONS.SET_COMMUNICATION_ADDRESS:
			return { ...state, communicationAddress: action.payload }

		case ACTIONS.SET_KYC_POC_DETAILS:
			return { ...state, kycPocDetails: action.payload }

		default:
			return state
	}
}
